export const BUTTON_TYPES = {
  default: {
    label: null,
    type: "button",
    classes: ["btn"],
    styles: null,
    glyphicon: null,
  },
  search: {
    label: "検索する",
    type: "submit",
    classes: ["btn-success", "font-weight-bold"],
  },
  back: {
    classes: ["btn-default", "font-weight-bold"],
    label: "戻る",
  },
  cancel: {
    classes: ["btn-default", "font-weight-bold"],
    label: "キャンセル",
  },
  new: {
    label: "新規登録",
    classes: ["btn-success", "font-weight-bold"],
  },
  edit: {
    label: "編集する",
    classes: ["btn-success", "font-weight-bold"],
  },
  save: {
    label: "登録する",
    classes: ["btn-success", "font-weight-bold"],
  },
  delete: {
    label: "削除する",
    classes: ["btn-warning", "font-weight-bold"],
  },
  success: {
    classes: ["btn-success", "font-weight-bold"],
  },
  warning: {
    classes: ["btn-warning", "font-weight-bold"],
  },
  "primary-xs": {
    classes: ["btn-primary", "btn-xs"],
  },
  "warning-xs": {
    classes: ["btn-warning", "btn-xs"],
  },
  "to-list": {
    label: "一覧へ",
    glyphicon: "list",
  },
  execute: {
    label: "実行",
    classes: ["btn-primary"],
    glyphicon: "flash",
  },
};
